/**
 * Layout Components...
 */
require('./navbar/navbar')
require('./notifications/notifications')

/**
 * Kiosk Components...
 */
require('./kiosk/kiosk')
require('./kiosk/announcements')
require('./kiosk/users')
require('./kiosk/profile')
